import type InfiniteViewerManager from '@sceneio/content-shared-react-infinite-viewer/src/infinite-viewer/src/InfiniteViewerManager'
import { RefObject, createContext } from 'react'
import Moveable from '@sceneio/content-shared-moveable'
import Selecto from 'react-selecto'

type InfiniteCanvasContextType = {
  infiniteCanvasRef: RefObject<InfiniteViewerManager | null>
  selectToolRef: RefObject<Selecto | null>
  moveToolRef: RefObject<Moveable | null>
  isFocused?: boolean
  setIsFocused: (isFocused: boolean) => void
  getMouseCursorPosition: () => { x: number; y: number }
}

export const InfiniteCanvasContext = createContext<InfiniteCanvasContextType>(
  {} as any,
)
